import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { DEFAULT_COLOR_SCHEME, THEME_STORAGE_KEY } from '~/constants/theme'

function readStoredScheme() {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)

  if (stored === 'light' || stored === 'dark') {
    return stored
  }

  return DEFAULT_COLOR_SCHEME
}

export const useThemeStore = defineStore('theme', () => {
  const scheme = ref(DEFAULT_COLOR_SCHEME)

  const isDark = computed(() => scheme.value === 'dark')

  function applyScheme(value) {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(value)
    localStorage.setItem(THEME_STORAGE_KEY, value)
  }

  function setScheme(value) {
    scheme.value = value
    applyScheme(value)
  }

  function toggleScheme() {
    setScheme(isDark.value ? 'light' : 'dark')
  }

  /** Sync store state & DOM from localStorage (browser-only persistence). */
  function hydrateFromStorage() {
    const stored = readStoredScheme()
    scheme.value = stored
    applyScheme(stored)
  }

  return {
    scheme,
    isDark,
    setScheme,
    toggleScheme,
    hydrateFromStorage,
  }
})
